import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white font-poppins pt-20">
      {/* Main Hero Part of AboutUs */}

      {/* Main Hero Part of AboutUs */}
      <section className="py-24 lg:py-32 bg-slate-50 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="space-y-10"
            >
              <div className="space-y-6 text-left">
                <div className="inline-flex items-center gap-3">
                  <div className="w-10 h-[1px] bg-syana-blue-600"></div>
                  <span className="text-[10px] font-black uppercase tracking-[0.4em] text-syana-blue-600">Our Heritage</span>
                </div>
                <h1 className="text-5xl lg:text-8xl font-black text-slate-900 leading-[1.0] tracking-tighter">
                  Vision <br />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-syana-blue-600 via-slate-900 to-syana-blue-600 animate-wave-gradient">Excellence</span>
                </h1>
              </div>
              <p className="text-slate-500 text-lg lg:text-xl leading-relaxed font-medium max-w-xl text-left">
                With nearly 30 years of operations, we have successfully become the first company locally to bring the eye care industry on par with global standards.
              </p>
            </motion.div>
            
            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1 }}
              className="relative"
            >
              <img 
                src="https://images.unsplash.com/photo-1576091160550-2173bdb999ef?q=80&w=2070&auto=format&fit=crop" 
                alt="Clinic Interior" 
                className="w-full h-[500px] lg:h-[700px] object-cover rounded-3xl shadow-2xl"
              />
              <div className="absolute -bottom-10 -left-10 bg-white p-8 rounded-3xl shadow-2xl space-y-2 hidden lg:block">
                <p className="text-4xl font-black text-syana-blue-600 tracking-tight">29+</p>
                <p className="text-[10px] font-black uppercase tracking-widest text-slate-400">Years of Experience</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Detailed Content Section */}
      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-4xl mx-auto px-6 space-y-16 text-left">
          <div className="space-y-8">
            <h2 className="text-3xl lg:text-4xl font-black text-slate-900 tracking-tight">Our Mission & Vision</h2>
            <p className="text-slate-600 text-lg lg:text-xl leading-relaxed">
              The Siyane Optometrists Group has built a reputation as one of the best eye care solution providers in the region by using an innovative approach and state-of-the-art equipment to ensure that customers receive world-class eye care at all branches.
            </p>
            <p className="text-slate-600 text-lg lg:text-xl leading-relaxed">
              Our commitment goes beyond just providing lenses; we focus on overall vision health and clinical excellence. We partner with global vision councils to bring the latest technology to Sri Lanka.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 pt-8">
            <div className="space-y-6 p-10 bg-slate-50 rounded-3xl transition-transform hover:-translate-y-2 duration-500">
              <div className="w-14 h-14 bg-syana-blue-600/10 rounded-2xl flex items-center justify-center text-syana-blue-600 text-2xl">
                <i className="fa-solid fa-eye"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 tracking-tight">Clinical Precision</h3>
              <p className="text-slate-500 text-sm leading-relaxed">
                Using the most advanced diagnostic tools to ensure every prescription is perfect and every eye condition is detected early.
              </p>
            </div>
            <div className="space-y-6 p-10 bg-slate-50 rounded-3xl transition-transform hover:-translate-y-2 duration-500">
              <div className="w-14 h-14 bg-syana-blue-600/10 rounded-2xl flex items-center justify-center text-syana-blue-600 text-2xl">
                <i className="fa-solid fa-award"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 tracking-tight">Global Standards</h3>
              <p className="text-slate-500 text-sm leading-relaxed">
                We are proud to be the first in our region to match international optometry benchmarks across all our branches.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Block */}
      <section className="py-24 lg:py-32 bg-slate-900 relative overflow-hidden">
        <div className="max-w-4xl mx-auto px-6 text-center space-y-10 relative z-10">
          <h2 className="text-4xl lg:text-6xl font-black text-white tracking-tight leading-tight">
            Ready to See the <br />World Differently?
          </h2>
          <p className="text-white/40 text-lg max-w-xl mx-auto">
            Experience premium eye care tailored to your unique lifestyle. Visit any of our branches for a comprehensive consultation.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-6 pt-6">
            <a 
              href="tel:+94117575100"
              className="px-12 py-5 bg-syana-blue-600 text-white rounded-2xl font-black uppercase text-xs tracking-[0.3em] hover:bg-syana-blue-500 transition-all shadow-xl shadow-syana-blue-600/20 active:scale-95 text-center"
            >
              Book Appointment
            </a>
            <Link to="/" className="px-12 py-5 bg-white/5 border border-white/10 text-white rounded-2xl font-black uppercase text-xs tracking-[0.3em] hover:bg-white/10 transition-all active:scale-95">
              Back to Home
            </Link>
          </div>
        </div>
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-syana-blue-600/10 rounded-full blur-[120px] -z-0"></div>
      </section>
    </div>
  );
};

export default AboutUs;
